import gsap from "../src/js/gsap/src/index.js"

//import TextPlugin from "../src/js/gsap/src/TextPlugin.js"
//gsap.registerPlugin(TextPlugin)

import SplitText from "../src/js/gsap/src/SplitText.js"
gsap.registerPlugin(SplitText)

import scrollTrigger from "../src/js/gsap/src/ScrollTrigger.js"
gsap.registerPlugin(scrollTrigger)

import DrawSVGPlugin from "../src/js/gsap/src/DrawSVGPlugin.js"
gsap.registerPlugin(DrawSVGPlugin)

//import Draggable from "../src/js/gsap/src/Draggable.js";
//gsap.registerPlugin(Draggable)

//import InertiaPlugin from "../src/js/gsap/src/InertiaPlugin.js"
//gsap.registerPlugin(InertiaPlugin)
